<script lang="ts" setup>
import { dir } from '@@/bits/current_dir'
import { recordWhitelistedClick } from '@@/bits/pepin'
import { defineAsyncComponent } from '@@/bits/vue'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import { useSurfaceGroupPickerStore } from '@@/pinia/surface_group_picker'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import { useSurfaceSectionsStore } from '@@/pinia/surface_sections'
import { useSurfaceWishArrangementStore } from '@@/pinia/surface_wish_arrangement'
import { useWindowSizeStore } from '@@/pinia/window_size'

const ContentPickerForSurfaceAddPost = defineAsyncComponent(
  () => import('@@/vuecomponents/ContentPickerForSurfaceAddPost.vue'),
)
import { storeToRefs } from 'pinia'

const SurfaceGroupPicker = defineAsyncComponent(() => import('@@/vuecomponents/SurfaceGroupPicker.vue'))

const windowSizeStore = useWindowSizeStore()
const surfaceSectionsStore = useSurfaceSectionsStore()
const surfacePermissionsStore = useSurfacePermissionsStore()
const darkModeStore = useDarkModeStore()
const { isDarkMode } = storeToRefs(darkModeStore)

const surfaceWishArrangementStore = useSurfaceWishArrangementStore()

const surfaceGroupPickerStore = useSurfaceGroupPickerStore()
const { isVisible: xGroupPicker, title: groupPickerTitle } = storeToRefs(surfaceGroupPickerStore)

const { windowHeight } = storeToRefs(windowSizeStore)

const surfaceContainerSizeStore = useSurfaceContainerSizeStore()
const { isContainerSmallerThanTabletPortrait } = storeToRefs(surfaceContainerSizeStore)
</script>

<template>
  <div :dir="dir()" class="z-addpost" @click.stop="recordWhitelistedClick" @keydown.stop="() => {}">
    <ContentPickerForSurfaceAddPost />
    <SurfaceGroupPicker
      v-if="xGroupPicker"
      :groups="surfaceWishArrangementStore.sortedGroups"
      :excluded-group-ids="surfaceGroupPickerStore.excludedGroupIds"
      :dark-mode="isDarkMode"
      :window-height="windowHeight"
      :full-size="isContainerSmallerThanTabletPortrait"
      :can-create-new-group="surfacePermissionsStore.canCreateNewGroup"
      :post-group-by="surfaceWishArrangementStore.wishGroupBy"
      :create-section="surfaceSectionsStore.createSectionWithName"
      :title="groupPickerTitle"
    />
  </div>
</template>
